import axios from 'axios';
import React, { Component, useState } from 'react';
import './Footer.css';
const checkCircleImage= 'https://testwire.wockhardt.com/uploads/youtube_com_5d0be3242a.png';

const BASE_URL = 'https://testwire.wockhardt.com';
let dotp = '';
let uotp = '';

//const [message, setMessage] = useState("");
const jwt = localStorage.getItem('jwt'); // get the JWT token from local storage

const handleLogout = () => {
    // Clear token from local storage
    localStorage.removeItem('jwt');
    // Redirect to login page
    window.location.href = '/login';
  }

 // Add this utility function to generate a random OTP
 const generateRandomOTP = () => {
  const length = 4; // You can adjust the length of the OTP
  const characters = '0123456789';
  let OTP = '';

  for (let i = 0; i < length; i++) {
    const index = Math.floor(Math.random() * characters.length);
    OTP += characters.charAt(index);
  }

  return OTP;
};


class newcontact extends React.Component 
{
  state = {showDiv1: false,showDiv: false, data1: null,data2:null,responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',education:'',previousemployment:'',address:'',pan:'',aadhar:'',uan:'',contactno:'',designation:'',empcode:'',Gender:'',dob:'',positioN_CODE:'',position:'',area:'',subarea:'',subgroup:'',doj:'',companY_CODE:'',cosT_CENTER:'',worK_CNTRCT:'',organization:'',communication:'',flM_CODE:'',reP_MGR:'',peR_ADMIN:'',paY_ADMIN:'',orG_CODE:'',profileapproved:'',salutation:'',firstName:'',lastName:'',middleName:'',aadharName:'',officialEmail:'',personalMobile:'',bankName:'',bankAccountNo:'',ifsc:'',pfNo:'',passportNo:'',personalEmail:'',officeTelNo:'',officeMobile:'',password:'',  submissionStatus: null, peR_ADMIN_CODE:'',peR_ADMIN_EMAIL:'',funC_HEAD_CODE:'',funC_HEAD_EMAIL:'',country:'',jobrole:'',generatedOTP:''};

  fetchData1 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        this.setState({ data1: res.data });
      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        //console.log(`API response for user data with id ${userId}:`, res);
        this.setState({ responseData: res.data });
        let username = res.data.username;
        let email = res.data.email;
        let empcode = res.data.empcode;
        let pictureurl = res.data.picture.url;
        let officeMobile = res.data.officeMobile;
        ////console.log('empcode:', officeMobile); 
        uotp = res.data.motp;
        this.setState({ username });
        this.setState({ email });
        this.setState({ empcode });
        this.setState({ pictureurl });
        this.setState({ officeMobile });
        this.setState({ uotp });
      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };
  

updateUserData = (id, supdatedData) => {
  //this.fetchUserData();
  //console.log(uotp);
  //console.log(this.state.generatedOTP);
  //console.log('Test verify');
  if( dotp != this.state.generatedOTP ){
    alert('Invalid OTP!');
    return;
  }
  let updatedDataw = {
    officeMobile: this.state.officeMobile,
    qr_mobile: this.state.officeMobile,
    motp: generateRandomOTP(),
  };
  axios.put(`${BASE_URL}/api/users/${id}`, updatedDataw,{
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Content-Type': 'application/json'
      },
    })
      .then(res => {
        alert('Mobile Number updated successfully');
        window.location.href = '/';
      })
      .catch(error => {
        this.setState({
            submissionStatus: 'error', 
          });
      });
  };

  componentDidMount() {
    this.fetchData1();
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    let officeMobile = jwtDataParsed.user.officeMobile;
    //console.log(officeMobile,'officemobile');
    let generatedOTP = jwtDataParsed.user.generatedOTP;
    this.setState({ id });
    this.fetchUserData(id);    
    this.setState({ officeMobile });
    this.setState({ generatedOTP });
  }

  handleClick = () => {
    this.setState({
      showDiv: !this.state.showDiv,
    });
  };
  
  handleClickOTP = async () => {
    await this.sendOTP();
    let motp = dotp; // Generate OTP
    this.setState({ motp }); // Update state
    //console.log(BASE_URL);
    //console.log(motp);
    //console.log('Test OTP');
    let isUniqueNumber = this.state.officeMobile;
    if (isUniqueNumber) {
        this.setState({ showDiv1: true });
        let updatedDatax = {
            motp: motp,
        };

        let didx = this.state.id;
        
        axios.put(`${BASE_URL}/api/users/${didx}`, updatedDatax,{
          headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
        })
          .then(res => {
            alert('OTP sent successfully');
            //window.location.href = '/';      
          })
          .catch(error => {
            this.setState({
                submissionStatus: 'error', 
              });
          });
    } else {
        console.error("Office mobile number already exists");
    }
};

  handleInputChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    const name = event.target.name;

    if (name === 'profileapproved') {
        this.setState({
            [name]: value
        });
    } else {
        this.setState({
            [name]: value,
            profileapproved: value === true ? "true" : "false"
        });
    }
}

sendOTP = () => {
    const { officeMobile } = this.state;
  
    if (!/^\d{10}$/.test(officeMobile)) {
      console.error('Invalid office mobile number');
      return;
    }
  
    const generatedOTP = generateRandomOTP();
    dotp = generatedOTP;

    const otpApiUrl = `https://www.smsstriker.com/API/sms.php?username=WOCKHARDT&password=Wock@123&from=WCKSMS&to=${officeMobile}&msg=${generatedOTP} is your OTP to validate mobile number for E2 portal. - Wockhardt Ltd`;

      axios.get(otpApiUrl,{ timeout: 5000 })
  .then(res => {
    //console.log('OTP sent successfully:', res.data);
    this.setState({
        otpSent: true,
      });
  })
  .catch(error => {
    if (error.response) {
      console.error('Server responded with error status:', error.response.status);
      console.error('Response data:', error.response.data);
    } else if (error.request) {
      console.error('No response received from the server');
    } else {
      console.error('Error setting up the request:', error.message);
    }
    console.error('Full error details:', error);
  });

  };

  render() {
    let updatedData = {
        officeMobile:this.setState.officeMobile,
        generatedOTP: this.setState.generatedOTP
      };
      let submissionMessage;
  if (this.state.submissionStatus === 'success') {
    submissionMessage = <div className="text-green-500">Number updated successfully!</div>;
  } else if (this.state.submissionStatus === 'error') {
    submissionMessage = <div className="text-red-500">Error submitting request. Please try again.</div>;
  }
    if (this.state.data1 === null || this.state.responseData === null) 
    {
      return <div>Loading...</div>;
    }
    return (
        <div className='bg-silver1'>
            <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
                <div className="flex justify-between mb-2" > 
                    <div className='mt-3 ml-5'>
                        <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
                    </div>
                    <div className='flex'>
                        <ul class="navbar-list">
                     <li>
                        <img style={{marginTop:5, marginRight:5,cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={`${BASE_URL}${this.state.pictureurl}`} alt={this.state.picture.alternativeText}  class="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white"  onClick={this.handleClick} />
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {this.state.username} </h5>
                                  <span class="text-white text-xs">{this.state.email}</span>
                                  <p class="text-white text-xs">{this.state.empcode}</p>
                                 </div>
                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                    <a className="iq-bg-danger iq-sign-btn" href="/generateevisitingcard" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate eVisitingCard<i className="ri-login-box-line ml-2"></i></a>
                                    <a className="iq-bg-danger iq-sign-btn" href="#" role="button" onClick={handleLogout} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i className="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                        </ul>
                    </div>
                </div>
                <div style={{ display: 'flex',  justifyContent:'space-around'  }} >  
                    {this.state.data1.data.map(item => (
                        <div  className="mb-1">
                            <div className="col-md-4" key={item.id}>
                                <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bg-silver1 pt-32'/>  

            <div className='bg-silver1'>
                <section>     
                    <div className="bg-silver1">
                        <div className='lg:flex justify-around mx-4'>
                            <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 shadow-xl lg:w-[100%]' style={{background:'#fff', marginBottom:20, position:"relative", borderRadius:25, fontSize:16, fontWeight:400 }}>
                                <div className='justify-between'> 
                                        <div className='lg:flex justify-around'>
                                                <div>
                                                    <div className="form-group text-xs" style={{ marginTop: 10, fontWeight: 400 }}>
                                                        {!this.state.showDiv1 && ( 
                                                            <label htmlFor="exampleInputPassword1" style={{ display: "inline-block" }}>Official Contact No</label>
                                                        )}
                                                    </div>
                                                    {!this.state.showDiv1 && (
                                                        <div className="form-group text-xs" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', background: '#eee', marginBottom: 0, paddingTop: 6, paddingRight: 4, paddingLeft: 4, paddingBottom: 6, fontWeight: 400, borderRadius: 4 }}>
                                                            <input className='text-xs' style={{ flex: 1, background: '#eee', marginBottom: 0, paddingTop: 2, paddingBottom: 2, fontWeight: 400, borderRadius: 4 }} type="text" name="officeMobile" placeholder="Enter your Official Contact No" value={this.state.officeMobile} onChange={this.handleInputChange} />
                                                            <button className='bg-blue btn btn-primary text-xs' style={{padding:10,color:'#fff',borderRadius:5}} type="button" onClick={() => this.handleClickOTP()}>Send OTP
                                                              {/* <img style={{ width: '10px', height: '10px' }} src="http://3.110.174.33:1337/uploads/download_f3ad02474a.svg" alt="Send OTP" title='Send OTP' /> */}
                                                            </button>
                                                        </div>
                                                    )}
                                                    {this.state.showDiv1 && (
                                                    <>
                                                    <div className="form-group text-xs" style={{ marginTop: 10, fontWeight: 400 }}>
                                                        <label htmlFor="exampleInputPassword1" style={{ display: "inline-block" }}>Enter OTP</label>
                                                        <div className="form-group text-xs" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', background: '#eee', marginBottom: 0, paddingTop: 6, paddingRight: 4, paddingLeft: 4, paddingBottom: 6, fontWeight: 400, borderRadius: 4 }}>
                                                          <input className="text-xs" style={{width: '100%',background: '#eee',marginBottom: 0,paddingTop: 6,paddingRight: 12,paddingLeft: 12,paddingBottom: 6,fontWeight: 400,borderRadius: 4,}} type="text" name="generatedOTP" placeholder="Enter OTP" value={this.state.generatedOTP} onChange={this.handleInputChange} />
                                                          <button className='bg-blue btn btn-primary text-xs' style={{padding:10,color:'#fff',borderRadius:5}} type="button" onClick={() => this.updateUserData(this.state.id,updatedData, { profileapproved: this.state.profileapproved })}>Submit</button>
                                                        </div>
                                                    </div>
                                                    <div className='bg-silver1'>
                                                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                            {submissionMessage}
                                                        </div>
                                                    </div>
                                                    </>
                                                    )}
                                                </div>
                                            </div>
                                        <div style={{ visibility: 'hidden' }}>
                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Profile Approved</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="profileapproved" placeholder="Enter your ORG Code" value={this.state.profileapproved} onChange={this.handleInputChange} />
                                                </div> 
                                        </div>
                                        {/* <div style={{textAlign:'center'}} >
                                          <button className='bg-blue btn btn-primary text-xs' style={{padding:10,color:'#fff',borderRadius:5}} type="button" onClick={() => this.updateUserData(this.state.id,updatedData, { profileapproved: this.state.profileapproved })}>Submit</button>
                                        </div>
                                        <div className='bg-silver1'>
                                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                {submissionMessage}
                                            </div>
                                        </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="footer">
                        <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 pr-3 text-xs text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
                    </div>
                </section>
            </div>
        </div>
    );
  }
}
export default newcontact;
